import { useState, useRef, useEffect } from "react";

import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

import {
  getMCQContext,
  setMCQContext
} from "../utils/mcqContext";

console.log(
  "FLOW TYPE =",
  localStorage.getItem(
    "flow_type"
  )
);



  const Dashboard = () => {

  const navigate =
    useNavigate();

  const location =
    useLocation();

  const params =
    new URLSearchParams(
      location.search
    );

  const flowType =
    params.get("flow") ||
    "mcq";

  const context =
    getMCQContext();

  const rawUser =
    JSON.parse(
      localStorage.getItem(
        "user"
      )
    );

  const user = rawUser
    ? {
        name:
          rawUser.full_name ||
          rawUser.name ||
          "User",

        email:
          rawUser.email ||
          "Not provided",

        picture:
          rawUser.avatar ||
          rawUser.picture ||
          "https://ui-avatars.com/api/?name=User&background=2563eb&color=fff",

        provider:
          rawUser.provider ||
          "Social Login"
      }
    : null;

  const [showProfile, setShowProfile] =
    useState(false);

  const profileRef =
    useRef(null);

  const [packages, setPackages] =
    useState([]);

  const [loading, setLoading] =
    useState(true);

  const [paperType, setPaperType] =
    useState("model_papers");

  /* ================= PROTECTION ================= */

  useEffect(() => {

    if (!rawUser) {

      navigate("/auth");

      return;

    }

    if (
      !context?.teacherId ||
      !context?.moduleId
    ) {

      navigate("/mcq");

      return;

    }

  }, []);

  /* ================= NAVBAR ================= */

  useEffect(() => {

    const navbar =
      document.querySelector(".navbar");

    const handleScroll = () => {

      const currentScroll =
        window.pageYOffset;

      if (!navbar) return;

      if (currentScroll <= 10) {

        navbar.style.transform =
          "translateX(-50%) translateY(0)";

        navbar.style.opacity = "1";

      }

      else {

        navbar.style.transform =
          "translateX(-50%) translateY(-130%)";

        navbar.style.opacity = "0";

      }

    };

    if (navbar) {

      navbar.style.position =
        "fixed";

      navbar.style.top =
        "15px";

      navbar.style.left =
        "50%";

      navbar.style.width =
        "90%";

      navbar.style.maxWidth =
        "1100px";

      navbar.style.transform =
        "translateX(-50%)";

      navbar.style.zIndex =
        "9999";

      navbar.style.transition =
        "all 0.35s ease";

    }

    window.addEventListener(
      "scroll",
      handleScroll
    );

    return () => {

      window.removeEventListener(
        "scroll",
        handleScroll
      );

      if (navbar) {

        navbar.style.transform =
          "translateX(-50%) translateY(0)";

        navbar.style.opacity =
          "1";

      }

    };

  }, []);

  /* ================= CLOSE PROFILE ================= */

  useEffect(() => {

    const close = (e) => {

      if (

        profileRef.current &&

        !profileRef.current.contains(
          e.target
        )

      ) {

        setShowProfile(false);

      }

    };

    document.addEventListener(
      "mousedown",
      close
    );

    return () =>

      document.removeEventListener(
        "mousedown",
        close
      );

  }, []);

  /* ================= LOAD PACKAGES ================= */

  useEffect(() => {

    fetch(
      "https://edunet.kmechengineering.com/root-engine1/api/packages"
    )

      .then(res => res.json())

      .then(data => {

        setPackages(
          data.package_data || []
        );

        setLoading(false);

      })

      .catch(() =>
        setLoading(false)
      );

  }, []);

  if (!user)

    return (

      <p style={{ padding: 40 }}>

        Please login first

      </p>

    );

  return (

    <div style={styles.container}>

      {/* ================= TOP BAR ================= */}

      <div style={styles.topBar}>

        <h2>

          Student Dashboard

        </h2>

        <div

          style={
            styles.profileTrigger
          }

          onClick={() =>

            setShowProfile(
              !showProfile
            )

          }

        >

          <img

            src={user.picture}

            alt="profile"

            style={
              styles.avatarSmall
            }

          />

          Hi {user.name}

        </div>

      </div>

      {/* ================= PROFILE POPUP ================= */}

      {showProfile && (

        <div

          style={
            styles.profileCard
          }

          ref={profileRef}

        >

          <img

            src={user.picture}

            alt="profile"

            style={
              styles.avatarLarge
            }

          />

          <h4>

            {user.name}

          </h4>

          <p>

            {user.email}

          </p>

          <button

            style={
              styles.logoutBtn
            }

            onClick={() => {

              localStorage.clear();

              window.location.href =
                "/auth";

            }}

          >

            Sign out

          </button>

        </div>

      )}

      {/* ================= HERO ================= */}

      <div style={styles.hero}>

        <h1 style={styles.heroTitle}>

          Welcome {user.name} 🎉

        </h1>

        <div style={styles.infoBox}>

          <span>

            <b>Subject:</b>{" "}

            {context?.subjectName &&
            context.subjectName !==
              "Unknown"

              ? context.subjectName

              : "Not selected"}

          </span>

          <span>

            <b>Teacher:</b>{" "}

            {context?.teacherName ||
              "Not selected"}

          </span>

        </div>

      </div>

      {/* ================= PAPER TYPE ================= */}

      <div style={styles.paperTypeWrapper}>

        <label style={styles.paperTypeCard}>

          <input
            type="radio"
            name="paperType"
            checked={
              paperType ===
              "model_papers"
            }

            onChange={() =>
              setPaperType(
                "model_papers"
              )
            }
          />

          <span>
            Model Papers
          </span>

        </label>

        <label style={styles.paperTypeCard}>

          <input
            type="radio"
            name="paperType"
            checked={
              paperType ===
              "past_papers"
            }

            onChange={() =>
              setPaperType(
                "past_papers"
              )
            }
          />

          <span>
            Past Papers
          </span>

        </label>

      </div>


      {/* ================= PACKAGE SECTION ================= */}

      <h2 style={styles.sectionTitle}>

        {flowType === "essay"
          ? "Essay Packages"
          : "MCQ Packages"}

      </h2>

      {loading && (

        <p>

          Loading packages...

        </p>

      )}

      <div style={styles.grid}>

        {packages.map(pkg => (

          <div
            key={pkg.id}
            style={styles.card}
          >

            <div style={styles.mcqGhost}>

              {flowType === "essay" ? (

                <>
                  Essay Question Preview
                  <br />
                  <br />
                  Write your answer here...
                  <br />
                  <br />
                </>

              ) : (

                <>
                  Q1. Sample MCQ Preview
                  <br />
                  A. ........
                  <br />
                  B. ........
                  <br />
                  C. ........
                  <br />
                  D. ........
                  <br />
                  <br />
                </>

              )}

            </div>

            <h3 style={styles.fg}>

              {pkg.title}

            </h3>

            <p
              style={{
                ...styles.fg,
                color: "#64748b"
              }}
            >

              {pkg.questions} Questions

            </p>

            <div style={styles.price}>

              Rs. {pkg.price}

            </div>

            <button

              style={styles.unlockBtn}

               onClick={() => {

                 if (
                   !context?.teacherId ||
                   !context?.moduleId
                 ) {

                   alert(
                     "Please select subject, teacher and module first."
                   );

                   navigate("/mcq");

                   return;

                 }

                 setMCQContext({

                   subjectId:
                     context.subjectId ||
                     null,

                   subjectName:
                     context.subjectName ||
                     "Unknown",

                   teacherId:
                     context.teacherId,

                   teacherName:
                     context.teacherName,

                   moduleId:
                     context.moduleId,

                   type: "paid"

                 });

                 if (
                   flowType === "essay"
                 ) {

                   navigate(
                     `/essay/paid/teacher/${context.teacherId}/${context.moduleId}/${pkg.questions}?type=${paperType}`
                   );

                   return;

                 }

                 navigate(
                   `/mcq/paid/teacher/${context.teacherId}/${context.moduleId}/${pkg.questions}?type=${paperType}`
                 );

               }}

            >

              Unlock Now

            </button>

            <div style={styles.watermark}>

              {flowType === "essay"
                ? "ESSAY PAPER PREVIEW"
                : "MCQ PAPER PREVIEW"}

            </div>

          </div>

        ))}

      </div>

    </div>

  );

};

/* ================= STYLES ================= */

const styles = {

  container: {

    padding: 56,

    minHeight: "100vh",

    background:
      "radial-gradient(circle at center,#1e293b,#0f172a,#020617)",

    color: "#e5e7eb"

  },

  topBar: {

    display: "flex",

    justifyContent:
      "space-between",

    padding: "18px 28px",

    background: "#020617",

    borderRadius: 20

  },

  profileTrigger: {

    display: "flex",

    gap: 10,

    cursor: "pointer"

  },

  avatarSmall: {

    width: 34,

    height: 34,

    borderRadius: "50%"

  },

  profileCard: {

    position: "absolute",

    top: 90,

    right: 56,

    background: "#fff",

    padding: 24,

    borderRadius: 20,

    color: "#000"

  },

  avatarLarge: {

    width: 80,

    borderRadius: "50%"

  },

  logoutBtn: {

    marginTop: 14,

    padding: 10,

    background: "#ef4444",

    color: "#fff",

    border: "none",

    borderRadius: 12

  },

  hero: {

    marginTop: 48

  },

  heroTitle: {

    fontSize: 36

  },

  infoBox: {

    marginTop: 16,

    display: "flex",

    gap: 28,

    background:
      "rgba(255,255,255,.08)",

    padding: "12px 22px",

    borderRadius: 14

  },

  paperTypeWrapper: {

    display: "flex",

    gap: 20,

    marginTop: 40,

    marginBottom: 10,

    flexWrap: "wrap"

  },

  paperTypeCard: {

    background: "#fff",
    color: "#000",
    padding: "18px 26px",
    borderRadius: 18,
    display: "flex",
    alignItems: "center",
    gap: 12,
    fontWeight: "bold",
    cursor: "pointer",
    minWidth: 180,

    boxShadow:
      "0 8px 20px rgba(0,0,0,0.2)"

  },

  sectionTitle: {

    marginTop: 30

  },

  grid: {

    marginTop: 24,

    display: "grid",

    gridTemplateColumns:
      "repeat(auto-fit,minmax(280px,1fr))",

    gap: 36

  },

  card: {

    background: "#fff",
    padding: 30,
    borderRadius: 20,
    textAlign: "center",
    color: "#000"

  },

  mcqGhost: {

    opacity: 0.3

  },

  fg: {},

  price: {

    fontSize: 24,
    fontWeight: "bold",
    marginBottom: 20

  },

  unlockBtn: {

    width: "100%",
    padding: 12,
    background: "#2563eb",
    color: "#fff",
    border: "none",
    borderRadius: 12,
    cursor: "pointer",
    fontWeight: "bold"

  },

  watermark: {

    fontSize: 10,
    marginTop: 16

  }

};

export default Dashboard;